import React, { useState, useEffect } from "react";
import { TrashIcon } from "@heroicons/react/24/outline";
import Cookies from 'js-cookie';

export default function UserManagent() {
  const [users, setUsers] = useState([]);
  const [usersN, setUsersN] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showQuizzesModal, setShowQuizzesModal] = useState(false);
  const [Quizzesu, setQuizzesu] = useState([]);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "",
  });

  useEffect(() => {
    const storedUser = JSON.parse(Cookies.get("user"));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  useEffect(() => {
    const NotaireUsers = async () => {
      try {
        const token = Cookies.get("token");
        const notaire = JSON.parse(Cookies.get("user"));
        if (notaire.role === "notaire") {
          console.log(notaire.role);
          const response = await fetch(`${process.env.REACT_APP_ADDRESS}/notaire-users/${notaire._id}`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          console.log(notaire._id);

          const data = await response.json();

          if (response.ok) {
            setUsersN(data);
            console.log(JSON.stringify(data));
          } else {
            throw new Error(data.message);
          }
        } else {
          console.log("User is not a notaire");
        }
      } catch (error) {
        console.log("error", error);
      }
    };
    NotaireUsers();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = Cookies.get("token");

        const response = await fetch(`${process.env.REACT_APP_ADDRESS}/users`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (response.ok) {
          setUsers(data);
        } else {
          throw new Error(data.message);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  const fetchUserQuizzes = async (userId) => {
    try {
      const token = Cookies.get("token");

      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/quizes/${userId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log(userId);

      const data = await response.json();

      if (response.ok) {
        setQuizzesu(data);
        setShowQuizzesModal(true);
        console.log(JSON.stringify(data));
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const toggleDeleteConfirmation = (userId) => {
    setSelectedUserId(userId);
    setShowDeleteConfirmation(!showDeleteConfirmation);
  };

  const handleDeleteUserAdmin = async (userId) => {
    try {
      const token = Cookies.get("token");

      console.log(userId);
      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/users/${userId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        // Remove the deleted user from the users array
        setUsers(users.filter((user) => user._id !== userId));
      } else {
        console.error("Error deleting user:", response);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-semibold leading-7 text-gray-900 pb-4">
        Admin Dashboard
      </h1>
      <h1 className="text-base font-semibold leading-7 text-gray-900">
        User&apos;s List
      </h1>
      <ul role="list" className="divide-y divide-gray-100">
        {showDeleteConfirmation && (
          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-4 rounded-md">
              <p>Are you sure you want to delete this user?</p>
              <div className="flex justify-end mt-4">
                <button
                  onClick={() => {
                    handleDeleteUserAdmin(selectedUserId);
                    setShowDeleteConfirmation(false);
                  }}
                  className="bg-red-500 text-white px-4 py-2 rounded-md mr-2"
                >
                  Delete
                </button>
                <button
                  onClick={() => setShowDeleteConfirmation(false)}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {users.map((user) => (
          <li
            key={user._id}
            className="flex items-center justify-between gap-x-6 py-5"
          >
            <div className="min-w-0">
              <div className="flex items-start gap-x-3">
                <p className="truncate">
                  {user.firstName} {user.lastName}
                </p>
              </div>
            </div>
            <div className="flex flex-none items-center gap-x-4">
              <button
                onClick={() => fetchUserQuizzes(user._id)}
                className="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                View User Quizzes
              </button>

              <button
                onClick={() => toggleDeleteConfirmation(user._id)}
                className="text-red-500"
              >
                <TrashIcon className="h-5 w-5" />
              </button>
            </div>
          </li>
        ))}
        {showQuizzesModal && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
            onClick={() => setShowQuizzesModal(false)}
          >
            <div
              className="relative bg-white rounded-lg shadow-lg p-6 max-w-md w-full mx-4"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none text-3xl"
                onClick={() => setShowQuizzesModal(false)}
              >
                &times;
              </button>
              <h2 className="text-3xl font-bold mb-6 text-center">
                User Quiz Results
              </h2>
              <ul className="space-y-4">
                {Quizzesu.map((quiz) => (
                  <li
                    key={quiz._id}
                    className="p-4 border border-gray-200 rounded-md shadow-sm bg-gray-50 hover:bg-gray-100 transition-colors"
                  >
                    <div className="flex justify-between items-center mb-2">
                      <h3 className="text-lg font-semibold">{quiz.title}</h3>
                    </div>
                    <div className="text-sm text-gray-700">
                      <p>
                        <strong> Quiz Contract Suggestion:</strong>{" "}
                        {quiz.result}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
        {user.role === "notaire" && (
          <ul>
            {usersN.map((user) => (
              <li
                key={user._id}
                className="flex items-center justify-between gap-x-6 py-5"
              >
                <div className="min-w-0">
                  <div className="flex items-start gap-x-3">
                    <p className="truncate">
                      {user.firstName} {user.lastName}
                    </p>
                  </div>
                </div>
                <div className="flex flex-none items-center gap-x-4">
                  <button
                    onClick={() => fetchUserQuizzes(user._id)}
                    className="bg-blue-500 text-white px-4 py-2 rounded-md"
                  >
                    View Details
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </ul>
    </div>
  );
}
